// Model numbers, voltages and amp ratings in a title (same rules as the server's specs.py) for filtering on the phone.
const VOLT = /(\d+(?:\.\d+)?)\s*-?\s*(?:v|volts?|vac|vdc)\b/gi;
const AMP = /(\d+(?:\.\d+)?)\s*-?\s*(ah|mah|a|amps?|amperes?)\b/gi;
const MODEL = /\b(?=[a-z0-9\-./]*[a-z])(?=[a-z0-9\-./]*\d)[a-z0-9][a-z0-9\-./]{2,}[a-z0-9]\b/gi;
const num = (s) => String(parseFloat(s));
const flat = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
const whole = (re, s) => new RegExp(`^(?:${re.source})$`, "i").test(s);

export function specs(text) {
  const t = String(text || "");
  const volts = new Set([...t.matchAll(VOLT)].map((m) => num(m[1])));
  const amps = new Set([...t.matchAll(AMP)].map(([, n, u]) => {
    const unit = u.toLowerCase();
    return unit === "mah" ? `${num(parseFloat(n) / 1000)}ah` : `${num(n)}${unit === "ah" ? "ah" : "a"}`;
  }));
  const models = new Set((t.match(MODEL) || []).filter((m) => !whole(VOLT, m) && !whole(AMP, m)).map(flat).filter((m) => m.length >= 4));
  return { volts, amps, models };
}

// The filter box: a bare number means volts; returns null when nothing usable was typed.
export function readSpecFilter(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  const w = specs(/^\d+(\.\d+)?$/.test(s) ? `${s}v` : s);
  return w.volts.size || w.amps.size || w.models.size ? w : null;
}

export function specHas(text, want) {
  const have = specs(text);
  for (const v of want.volts) if (!have.volts.has(v)) return false;
  for (const a of want.amps) if (!have.amps.has(a) && !(a.endsWith("a") && have.amps.has(`${a}h`))) return false;
  const f = flat(text);
  for (const m of want.models) if (!f.includes(m)) return false;
  return true;
}
